import { Component, Input, isDevMode, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import {environment} from "../../../../../environments/environment";
import {Centre} from "../../../../interfaces/Centres";
import {CentreService} from "../../../../services/centre.service";
import {Observable, Subject} from "rxjs";
import {take, takeUntil} from "rxjs/operators";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import * as XLSX from 'xlsx';
import {LoadingService} from "../../../../services/loading.service";
import {PermissionType} from "../../../../components/employee/PermissionType.enum";
import {FinancialYearService} from "../../../../services/financial-year.service";
import {endOfDay} from '../../../../utils/date-range-format.service';
@Component({
  selector: 'app-education-mis-reposrt',
  templateUrl: './education-mis-reposrt.component.html',
  styleUrls: ['./education-mis-reposrt.component.scss']
})
export class EducationMisReposrtComponent implements OnInit, OnChanges, OnDestroy {
  env = isDevMode() ? environment.testMode : environment.productionMode;
  private _destroyed$ = new Subject<void>();
  // External inputs from parent (education-presentation)
  @Input() hideFilters: boolean = false;
  @Input() externalStartDate: Date | null = null;
  @Input() externalEndDate: Date | null = null;
  @Input() externalCentre: string | string[] = '';
  @Input() triggerSearch: number = 0;

  mCentres: Centre[] = [];
  centres$: Observable<Centre[]>;
  allCentres: any[] = [];
  selectedCentreCode: any = '';
  headers: string[] = [];
  startDate: Date | any;
  endDate: Date | any;
  selectedCentre = 'All'
  mTotalDischarge: number = 0;
  educationData: any;
  highlights: any = '';
  mId: string | undefined
  sessionCounts: { [key: string]: { [key: string]: number } } = {};
  centerAverages: number[] = [];
  childAverages: number[] = [];
  allRapportBuildingSessionCount: any[] = [];
  allRapportBuildingSessionCountTotal = 0 ;
  allBaselineAssessmentSessionCount : any[] = [];
  allBaselineAssessmentSessionCountTotal = 0 ;
  allIntermediateAssessmentSessionCount :any[] = [];
  allIntermediateAssessmentSessionCountTotal = 0;
  allDischargeTestSessionCount :any [] = [];
  allDischargeTestSessionCountTotal = 0;
  allIndividualSessionsByALTeacherCount :any [] = [];
  allIndividualSessionsByALTeacherTotal  = 0;
  allIndividualSessionsdoneVolunteersCount: any[] = [];
  allIndividualSessionsdoneVolunteersTotal = 0;
  // Row G: Group sessions by Teacher, countType !== 'bychildren', count = 1
  allGroupSessionsCount: any[] = [];
  allGroupSessionsTotal = 0;
  // Row H: Group sessions by Volunteer, count = bychildren ? children.length : 1
  allGroupSessionsByVolunteerCount: any[] = [];
  allGroupSessionsByVolunteerTotal = 0;
  // Row I: Unaccounted group sessions (conductedBy not Teacher or Volunteer)
  allGroupSessionsUnaccountedCount: any[] = [];
  allGroupSessionsUnaccountedTotal = 0;
  // Raw unaccounted sessions for the debug table
  unaccountedRawSessions: any[] = [];
  // Fix-conductedBy operation state
  fixingConductedBy = false;
  fixConductedByStatus = '';
  fixConductedByUpdated = 0;
  private pendingSearch = false;
  constructor( private centreService: CentreService,
               private loadingService: LoadingService,
               private mFirestore: AngularFirestore,
               private readonly financialYearService: FinancialYearService,) {
    this.centres$ = this.centreService.getAllCentres();
    this.centres$.pipe(takeUntil(this._destroyed$)).subscribe(res => {
      this.allCentres = res
        .filter(c => c.centreCode !== 'ALBandra')
        .sort((a, b) => a.centreName.localeCompare(b.centreName));
      this.headers = this.allCentres.map(c => c.centreName);

      // Recalculate mCentres based on current selection so a fresh centres$ emission
      // never clobbers what Search() already filtered.
      const selected: string[] = Array.isArray(this.selectedCentreCode)
        ? this.selectedCentreCode
        : (this.selectedCentreCode ? [this.selectedCentreCode as string] : []);
      this.mCentres = selected.length > 0
        ? this.allCentres.filter(c => selected.includes(c.centreCode))
        : [...this.allCentres];

      // If ngOnChanges fired before centres$ was ready, run the deferred search now
      if (this.pendingSearch) {
        this.pendingSearch = false;
        this.Search();
      }
    })
  }
  ngOnInit(): void {
    // Only default here in standalone mode — nested mode (hideFilters=true) is fully
    // driven by externalStartDate/externalEndDate via ngOnChanges.
    if (this.hideFilters) return;
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate = fy.startDate;
    this.endDate = fy.endDate;
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Helper: resolve centre codes from external input (supports both string and string[])
    const resolveCentreCodes = (): string[] => {
      const input = this.externalCentre;
      if (Array.isArray(input)) {
        const filtered = input.filter(c => c && c !== 'All Centres' && c !== 'All');
        return filtered.length > 0 ? filtered : this.allCentres.map((c: any) => c.centreCode);
      }
      if (!input || input === 'All Centres' || input === 'All') {
        return this.allCentres.map((c: any) => c.centreCode);
      }
      return [input];
    };

    // Sync external inputs from parent component (always, regardless of hideFilters)
    if (changes['externalStartDate'] && this.externalStartDate) {
      this.startDate = this.externalStartDate;
    }
    if (changes['externalEndDate'] && this.externalEndDate) {
      this.endDate = this.externalEndDate;
    }
    if (changes['externalCentre']) {
      this.selectedCentreCode = resolveCentreCodes();
    }

    // Trigger search when parent increments the counter
    if (changes['triggerSearch'] && changes['triggerSearch'].currentValue > 0) {
      if (this.externalStartDate) this.startDate = this.externalStartDate;
      if (this.externalEndDate) this.endDate = this.externalEndDate;
      this.selectedCentreCode = resolveCentreCodes();
      // If allCentres is already loaded, search immediately.
      // Otherwise defer: the centres$ subscription will call Search() once centres arrive.
      if (this.allCentres.length > 0) {
        this.Search();
      } else {
        this.pendingSearch = true;
      }
    }
  }
  rapportBuildingSessionCount(data: any[], selectedCentreCodes: string[]) {
    const centerSessionCount: { [centreCode: string]: number } = {};
    const rapportBuildingSessions = data.filter((session: any) =>
      selectedCentreCodes.includes(session.centreCode) &&
      session.conductedBy === 'By Teacher' &&
      session.sessionType === 'Rapport Building' && session.present === 'Present'
    );
    rapportBuildingSessions.forEach((session: any) => {
      const centreCode = session.centreCode;  // Get the centreCode from the session
      if (!centerSessionCount[centreCode]) {
        centerSessionCount[centreCode] = 0;
      }
      centerSessionCount[centreCode]++;
    });
    this.allRapportBuildingSessionCount = this.mCentres.map(centre => {
      return {
        centreName: centre.centreName,
        sessionCountBySession: centerSessionCount[centre.centreCode] || 0
      };
    });
    this.allRapportBuildingSessionCountTotal = rapportBuildingSessions.length;
  }

  baselineAssessmentSessionCount(data: any[], selectedCentreCodes: string[]) {
    const centerSessionCount: { [centreCode: string]: number } = {};
    const baselineAssessmentSessions = data.filter((session: any) =>
      selectedCentreCodes.includes(session.centreCode) &&
      session.conductedBy === 'By Teacher' &&
      session.sessionType === 'Baseline Assessment' && session.present === 'Present'
    );
    baselineAssessmentSessions.forEach((session: any) => {
      const centreCode = session.centreCode;
      if (!centerSessionCount[centreCode]) {
        centerSessionCount[centreCode] = 0;
      }
      centerSessionCount[centreCode]++;
    });
    this.allBaselineAssessmentSessionCount = this.mCentres.map(centre => {
      return {
        centreName: centre.centreName,
        sessionCountBySession: centerSessionCount[centre.centreCode] || 0
      };
    });
    this.allBaselineAssessmentSessionCountTotal = baselineAssessmentSessions.length;
  }

  intermediateAssessmentSessionCount(data: any[], selectedCentreCodes: string[]) {
    const centerSessionCount: { [centreCode: string]: number } = {};

    // Filter sessions for 'Intermediate Assessment' type, 'Present' status, and selected centre codes
    const intermediateAssessmentSessions = data.filter((session: any) =>
      selectedCentreCodes.includes(session.centreCode) && // Filter by selected centre codes
      session.sessionType === 'Intermediate Assessment' && session.present === 'Present'
    );

    // Count the number of intermediate assessment sessions for each centre
    intermediateAssessmentSessions.forEach((session: any) => {
      const centreCode = session.centreCode;
      if (!centerSessionCount[centreCode]) {
        centerSessionCount[centreCode] = 0;
      }
      centerSessionCount[centreCode]++;
    });

    // Map the session count data for each centre
    this.allIntermediateAssessmentSessionCount = this.mCentres.map(centre => {
      return {
        centreName: centre.centreName,
        sessionCountBySession: centerSessionCount[centre.centreCode] || 0
      };
    });

    // Calculate the total count of intermediate assessment sessions
    this.allIntermediateAssessmentSessionCountTotal = intermediateAssessmentSessions.length;
  }

  // Row D: Individual Regular Study sessions from educationTest where conductedBy === 'By Volunteer'
  // sessionType restricted to 'Regular Study' to avoid double-counting with Rows A (Rapport Building),
  // B (Baseline Assessment), E (Intermediate Assessment) and F (Discharge Assessment)
  individualSessionsDoneVolunteers(data: any[], selectedCentreCodes: string[]) {
    const centerSessionCount: { [centreCode: string]: number } = {};
    const sessions = data.filter((s: any) =>
      selectedCentreCodes.includes(s.centreCode) &&
      s.conductedBy === 'By Volunteer' &&
      s.sessionType === 'Regular Study' &&
      s.present === 'Present'
    );
    sessions.forEach((s: any) => {
      if (!centerSessionCount[s.centreCode]) centerSessionCount[s.centreCode] = 0;
      centerSessionCount[s.centreCode]++;
    });
    this.allIndividualSessionsdoneVolunteersCount = this.mCentres.map(c => ({
      centreCode: c.centreCode,
      centreName: c.centreName,
      sessionCountBySession: centerSessionCount[c.centreCode] || 0
    }));
    this.allIndividualSessionsdoneVolunteersTotal = sessions.length;
  }

  dischargeTestSessionCount(data: any[], selectedCentreCodes: string[]) {
    const centerSessionCount: { [centreCode: string]: number } = {};
    const dischargeTestSessions = data.filter((session: any) =>
      selectedCentreCodes.includes(session.centreCode) &&
      session.sessionType === 'Discharge Assessment' && session.present === 'Present'
    );

    dischargeTestSessions.forEach((session: any) => {
      const centreCode = session.centreCode;
      if (!centerSessionCount[centreCode]) {
        centerSessionCount[centreCode] = 0;
      }
      centerSessionCount[centreCode]++;
    });

    this.allDischargeTestSessionCount = this.mCentres.map(centre => {
      return {
        centreName: centre.centreName,
        sessionCountBySession: centerSessionCount[centre.centreCode] || 0
      };
    });

    // Calculate total session count across all selected centres for Discharge Test
    this.allDischargeTestSessionCountTotal = dischargeTestSessions.length;
  }

  individualSessionsByALTeacherSessionCount(data: any[], selectedCentreCodes: string[]) {
    const centerSessionCount: { [centreCode: string]: number } = {};

    // Filter sessions based on selected centre codes
    const individualSessionsByALTeacher = data.filter((session: any) =>
      selectedCentreCodes.includes(session.centreCode) &&
      session.conductedBy === 'By Teacher' && session.present === 'Present'
    );

    const regularStudySessions = individualSessionsByALTeacher.filter((session: any) => session.sessionType === "Regular Study");

    regularStudySessions.forEach((session: any) => {
      const centreCode = session.centreCode;
      if (!centerSessionCount[centreCode]) {
        centerSessionCount[centreCode] = 0;
      }
      centerSessionCount[centreCode]++;
    });

    this.allIndividualSessionsByALTeacherCount = this.mCentres.map(centre => {
      return {
        centreName: centre.centreName,
        sessionCountBySession: centerSessionCount[centre.centreCode] || 0
      };
    });

    // Calculate total session count for Regular Study sessions conducted by AL Teacher
    this.allIndividualSessionsByALTeacherTotal = regularStudySessions.length;
  }

  // Row G: Group sessions by Teacher where countType !== 'bychildren', count each as 1
  groupSessionsSessionCount(data: any[], selectedCentreCodes: string[]) {
    const centreCodeWiseCount: { [key: string]: number } = {};
    data.forEach((session: any) => {
      if (session.conductedBy !== 'By Teacher') return;
      if (session.countType === 'bychildren') return;
      const centreCode = session.centreCode || session.centres?.[0]?.centreCode;
      if (!centreCode || !selectedCentreCodes.includes(centreCode)) return;
      if (!centreCodeWiseCount[centreCode]) centreCodeWiseCount[centreCode] = 0;
      centreCodeWiseCount[centreCode]++;
    });

    this.allGroupSessionsCount = this.mCentres.map((c: any) => ({
      centreCode: c.centreCode,
      sessionCountBySession: centreCodeWiseCount[c.centreCode] || 0
    }));
    this.allGroupSessionsTotal = Object.values(centreCodeWiseCount).reduce((total, count) => total + count, 0);
  }

  // Row H: Group sessions by Volunteer, count = bychildren ? children.length : 1
  groupSessionsByVolunteerCount(data: any[], selectedCentreCodes: string[]) {
    const centreCodeWiseCount: { [key: string]: number } = {};
    data.forEach((session: any) => {
      if (session.conductedBy !== 'By Volunteer') return;
      const centreCode = session.centreCode || session.centres?.[0]?.centreCode;
      if (!centreCode || !selectedCentreCodes.includes(centreCode)) return;
      const count = session.countType === 'bychildren' ? (session.children?.length || 0) : 1;
      if (!centreCodeWiseCount[centreCode]) centreCodeWiseCount[centreCode] = 0;
      centreCodeWiseCount[centreCode] += count;
    });
    this.allGroupSessionsByVolunteerCount = this.mCentres.map((c: any) => ({
      centreCode: c.centreCode,
      sessionCountBySession: centreCodeWiseCount[c.centreCode] || 0
    }));
    this.allGroupSessionsByVolunteerTotal = Object.values(centreCodeWiseCount).reduce((total, count) => total + count, 0);
  }

  // Row I: Unaccounted group sessions (conductedBy not 'By Teacher' or 'By Volunteer')
  groupSessionsUnaccountedCount(data: any[], selectedCentreCodes: string[]) {
    const centreCodeWiseCount: { [key: string]: number } = {};
    this.unaccountedRawSessions = [];

    data.forEach((session: any) => {
      if (session.conductedBy === 'By Teacher' || session.conductedBy === 'By Volunteer') return;
      const centreCode = session.centreCode || session.centres?.[0]?.centreCode;
      if (!centreCode || !selectedCentreCodes.includes(centreCode)) return;
      const count = session.countType === 'bychildren' ? (session.children?.length || 0) : 1;
      if (!centreCodeWiseCount[centreCode]) centreCodeWiseCount[centreCode] = 0;
      centreCodeWiseCount[centreCode] += count;
      // Store raw session for debug table
      this.unaccountedRawSessions.push({
        id: session.id || '—',
        sessionDate: session.sessionDate,
        countType: session.countType || '—',
        conductedBy: session.conductedBy ?? '(blank)',
        volunteerName: session.volunteerName || '—',
        centreCode,
        submittedBy: session.submittedBy || '—'
      });
    });
    this.allGroupSessionsUnaccountedCount = this.mCentres.map((c: any) => ({
      centreCode: c.centreCode,
      sessionCountBySession: centreCodeWiseCount[c.centreCode] || 0
    }));
    this.allGroupSessionsUnaccountedTotal = Object.values(centreCodeWiseCount).reduce((total, count) => total + count, 0);
  }

  calculateGrandTotal(): number[] {
    const sessionCounts = [
      this.allRapportBuildingSessionCountTotal,        // A
      this.allBaselineAssessmentSessionCountTotal,     // B
      this.allIndividualSessionsByALTeacherTotal,      // C
      this.allIndividualSessionsdoneVolunteersTotal,   // D
      this.allIntermediateAssessmentSessionCountTotal, // E
      this.allDischargeTestSessionCountTotal,          // F
      this.allGroupSessionsTotal,                      // G
      this.allGroupSessionsByVolunteerTotal,           // H
      this.allGroupSessionsUnaccountedTotal            // I
    ];
    const grandTotal = sessionCounts.reduce((acc, curr) => acc + curr, 0);
    return [grandTotal];
  }
  calculateCenterWiseTotalSessionSum(): number[] {
    const allSessionArrays = [
      this.allRapportBuildingSessionCount,           // A
      this.allBaselineAssessmentSessionCount,        // B
      this.allIndividualSessionsByALTeacherCount,    // C
      this.allIndividualSessionsdoneVolunteersCount, // D
      this.allIntermediateAssessmentSessionCount,    // E
      this.allDischargeTestSessionCount,             // F
      this.allGroupSessionsCount,                    // G
      this.allGroupSessionsByVolunteerCount,         // H
      this.allGroupSessionsUnaccountedCount          // I
    ];

    const centerWiseTotals: number[] = new Array(this.mCentres.length).fill(0);

    allSessionArrays.forEach((sessionArray) => {
      sessionArray.forEach((session, index) => {
        centerWiseTotals[index] += session.sessionCountBySession || 0;
      });
    });

    this.centerAverages = centerWiseTotals;
    return centerWiseTotals;
  }
  getGroupUniqChild() {
    if (this.startDate != null && this.endDate != null) {
      // Query the educationGroupTest collection with date range filtering
      this.mFirestore.collection(this.env.educationGroup, ref =>
        ref.where('sessionDate', '>=', this.startDate)
          .where('sessionDate', '<=', endOfDay(this.endDate))
      ).valueChanges().pipe(
        take(1),
        takeUntil(this._destroyed$)
      ).subscribe((res: any[]) => {
        // Object to hold unique children by center code
        const centerWiseChildCounts: { [centreCode: string]: Set<string> } = {};

        // Loop through the result set
        res.forEach(session => {
          if (session.children && Array.isArray(session.children)) {
            session.children.forEach((child: any) => {
              if (child.childCode && child.centreCode) {
                // Ensure the centerCode exists for the child
                if (!centerWiseChildCounts[child.centreCode]) {
                  centerWiseChildCounts[child.centreCode] = new Set<string>();
                }
                // Add the childCode to the respective center's set
                centerWiseChildCounts[child.centreCode].add(child.childCode);
              }
            });
          }
        });

        // Log the unique child count for each center
        Object.keys(centerWiseChildCounts).forEach(centreCode => {
          const uniqueChildrenCount = centerWiseChildCounts[centreCode].size;
        });

        // Optionally, return or store the center-wise counts if needed
        return centerWiseChildCounts;
      });
    } else {
    }
  }
  getIndividualUniqChild() {
    if (this.startDate != null && this.endDate != null) {
      // Query the educationTest collection with date range filtering
      this.mFirestore.collection(this.env.education, ref =>
        ref.where('sessionDate', '>=', this.startDate)
          .where('sessionDate', '<=', endOfDay(this.endDate))
          .where('present', '==', 'Present')
      ).valueChanges().pipe(
        take(1),
        takeUntil(this._destroyed$)
      ).subscribe((res: any[]) => {
        // Object to hold unique children by center code
        const centerWiseChildCounts: { [centreCode: string]: Set<string> } = {};

        // Loop through each session in the response
        res.forEach(session => {
          if (session.childCode && session.centreCode) {
            // Ensure the centerCode exists for the child
            if (!centerWiseChildCounts[session.centreCode]) {
              centerWiseChildCounts[session.centreCode] = new Set<string>();
            }
            // Add the childCode to the respective center's set
            centerWiseChildCounts[session.centreCode].add(session.childCode);
          }
        });

        // Log the unique child count for each center
        Object.keys(centerWiseChildCounts).forEach(centreCode => {
          const uniqueChildrenCount = centerWiseChildCounts[centreCode].size;
          console.log(`Centre: ${centreCode}, Unique Children: ${uniqueChildrenCount}`);
          this.getChildAvg(centreCode, uniqueChildrenCount);
        });

        // Optionally, return or store the center-wise counts if needed
        return centerWiseChildCounts;
      });
    } else {
    }
  }
  customRound(value: number): number {
    if (value % 1 >= 0.50 && value % 1 < 0.5) {
      return Math.ceil(value);
    }
    // Default rounding
    return Math.round(value);
  }
  getChildAvg(centreCode: string, uniqueChild: number): number {
    const centreIndex = this.mCentres.findIndex(centre => centre.centreCode === centreCode);
    const totalForCentre = this.calculateCenterWiseTotalSessionSum()[centreIndex] || 0
    const average = (uniqueChild > 0 && totalForCentre > 0) ? totalForCentre / uniqueChild : 0;
    this.childAverages[centreIndex] = average;
    this.childAverages = this.mCentres
      .map((centre, index) => ({ centreCode: centre.centreCode, avg: this.childAverages[index] })) // Map centre and avg
      .sort((a, b) => {
        const indexA = this.mCentres.findIndex(centre => centre.centreCode === a.centreCode);
        const indexB = this.mCentres.findIndex(centre => centre.centreCode === b.centreCode);
        return indexA - indexB; // Sorting based on the index in mCentres array
      })
      .map(item => item.avg); // Extract the sorted averages
    this.childAverages = this.childAverages.map(avg => avg === 0 ? 0 : avg);
    return average;
  }
  get totalAverage(): number {
    const total = this.childAverages.reduce((sum, avg) => sum + (avg || 0), 0);
    return total;
  }
  Search(){
    // ✅ Recalculate centre codes here in case allCentres wasn't ready during ngOnChanges
    if (!this.selectedCentreCode || this.selectedCentreCode.length === 0) {
      const input = this.externalCentre;
      if (Array.isArray(input)) {
        const filtered = input.filter(c => c && c !== 'All Centres' && c !== 'All');
        this.selectedCentreCode = filtered.length > 0 ? filtered : this.allCentres.map((c: any) => c.centreCode);
      } else if (!input || input === 'All Centres' || input === 'All') {
        this.selectedCentreCode = this.allCentres.map((c: any) => c.centreCode);
      } else {
        this.selectedCentreCode = [input];
      }
    }

    if (this.startDate != null && this.endDate != null) {
      this.loadingService.setLoading(true);
      this.mFirestore.collection(this.env.education, ref =>
        ref.where('sessionDate', '>=', this.startDate)
          .where('sessionDate', '<=', endOfDay(this.endDate))
      ).valueChanges().pipe(take(1), takeUntil(this._destroyed$)).subscribe((res: any) => {
        this.loadingService.setLoading(false);
        this.rapportBuildingSessionCount(res,this.selectedCentreCode);
        this.baselineAssessmentSessionCount(res,this.selectedCentreCode)
        this.intermediateAssessmentSessionCount(res,this.selectedCentreCode);
        this.dischargeTestSessionCount(res,this.selectedCentreCode);
        this.individualSessionsByALTeacherSessionCount(res,this.selectedCentreCode);
        this.individualSessionsDoneVolunteers(res,this.selectedCentreCode); // Row D - from educationTest
      })

      this.mFirestore.collection(this.env.educationGroup, ref =>
        ref.where('sessionDate', '>=', this.startDate)
          .where('sessionDate', '<=', endOfDay(this.endDate))
      ).valueChanges({idField: 'id'}).pipe(
        take(1),
        takeUntil(this._destroyed$)
      ).subscribe((res: any[]) => {
        this.groupSessionsSessionCount(res,this.selectedCentreCode);      // Row G
        this.groupSessionsByVolunteerCount(res,this.selectedCentreCode);  // Row H
        this.groupSessionsUnaccountedCount(res,this.selectedCentreCode);  // Row I
      })
    }
    this.mCentres = this.allCentres.filter(c => this.selectedCentreCode.includes(c.centreCode));
    this.calculateGrandTotal();
    this.calculateCenterWiseTotalSessionSum();
    this.getIndividualUniqChild();
    this.getGroupUniqChild();
  }
  Clear(): void {
    this.selectedCentreCode = ''
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate = fy.startDate;
    this.endDate = fy.endDate;
    this.allRapportBuildingSessionCount = [];
    this.allBaselineAssessmentSessionCount = [];
    this.allIndividualSessionsByALTeacherCount = [];
    this.allIndividualSessionsdoneVolunteersCount = [];
    this.allIntermediateAssessmentSessionCount = [];
    this.allDischargeTestSessionCount = [];
    this.allGroupSessionsCount = [];
    this.allGroupSessionsByVolunteerCount = [];
    this.allGroupSessionsUnaccountedCount = [];
    this.childAverages = [];
    // Reset totals
    this.allRapportBuildingSessionCountTotal = 0;
    this.allBaselineAssessmentSessionCountTotal = 0;
    this.allIndividualSessionsByALTeacherTotal = 0;
    this.allIndividualSessionsdoneVolunteersTotal = 0;
    this.allIntermediateAssessmentSessionCountTotal = 0;
    this.allDischargeTestSessionCountTotal = 0;
    this.allGroupSessionsTotal = 0;
    this.allGroupSessionsByVolunteerTotal = 0;
    this.allGroupSessionsUnaccountedTotal = 0;
    this.unaccountedRawSessions = [];
    // Optionally clear the loading state
    this.loadingService.setLoading(false);
  }
  // Bulk-fix: set conductedBy = 'By Volunteer' for all group sessions where countType === 'bychildren'
  async fixGroupSessionsConductedBy() {
    if (this.fixingConductedBy) return;
    this.fixingConductedBy = true;
    this.fixConductedByUpdated = 0;
    this.fixConductedByStatus = '🔍 Querying sessions...';

    try {
      const collectionRef = this.mFirestore.firestore.collection(this.env.educationGroup);
      let lastDoc: any = null;
      let totalUpdated = 0;

      while (true) {
        let query = collectionRef
          .where('countType', '==', 'bychildren')
          .orderBy('sessionDate')
          .limit(500);
        if (lastDoc) query = query.startAfter(lastDoc);

        const snap = await query.get();
        if (snap.empty) break;

        // Filter only docs that don't already have conductedBy = 'By Volunteer'
        const docsToUpdate = snap.docs.filter(
          (d: any) => d.data().conductedBy !== 'By Volunteer'
        );

        if (docsToUpdate.length > 0) {
          const batch = this.mFirestore.firestore.batch();
          docsToUpdate.forEach((d: any) => {
            batch.update(d.ref, { conductedBy: 'By Volunteer' });
          });
          await batch.commit();
          totalUpdated += docsToUpdate.length;
          this.fixConductedByUpdated = totalUpdated;
          this.fixConductedByStatus = `✅ Updated ${totalUpdated} sessions so far...`;
        }

        lastDoc = snap.docs[snap.docs.length - 1];
        if (snap.docs.length < 500) break;
      }

      this.fixConductedByStatus = `✅ Done! ${totalUpdated} sessions updated. Re-run Search to refresh counts.`;
    } catch (e: any) {
      this.fixConductedByStatus = `❌ Error: ${e?.message || e}`;
    } finally {
      this.fixingConductedBy = false;
    }
  }

  exportToExcel(): void {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(document.getElementById('MisTable'));
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'Education-MIS-Report.xlsx');
  }

  exportUnaccountedToExcel(): void {
    const rows = this.unaccountedRawSessions.map((s, i) => ({
      '#': i + 1,
      'Document ID': s.id,
      'Session Date': s.sessionDate?.toDate ? s.sessionDate.toDate().toLocaleDateString('en-GB') : s.sessionDate,
      'Count Type': s.countType,
      'Conducted By': s.conductedBy,
      'Volunteer Name': s.volunteerName,
      'Centre Code': s.centreCode,
      'Submitted By': s.submittedBy
    }));
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(rows);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Unaccounted');
    XLSX.writeFile(wb, 'Unaccounted-Group-Sessions.xlsx');
  }

  getCentreName(centreCode: string): string {
    const centre = this.allCentres.find(c => c.centreCode === centreCode);
    return centre ? centre.centreName : centreCode;
  }

  protected readonly PermissionType = PermissionType;

}


